import { ipsos, supuesto } from ".";

// Lámina 87 (tenencia/frecuencia/marcas, base 400) y lámina 96 (corporativo, base 400 —
// mismo dato que IPSOS_MOVIL.telefonoCorporativo de Telcos, cada categoría mantiene su copia).
const P_TIENE = "¿Tiene smartphone personal?";
const P_CORPORATIVO = "¿Tiene teléfono corporativo (de la empresa)?";
const P_FRECUENCIA = "¿Con qué frecuencia renueva su smartphone?";
const P_MARCA = "¿Cuál es la marca de su smartphone?";

export const IPSOS_SMARTPHONES = {
  tieneSmartphone: ipsos(0.954, { lamina: 87, pregunta: P_TIENE, base: 400 }),
  tieneCorporativo: ipsos(0.362, { lamina: 96, pregunta: P_CORPORATIVO, base: 400 }),

  frecuenciaRenovacion: {
    cadaAno: ipsos(0.161, { lamina: 87, pregunta: P_FRECUENCIA, base: 400 }),
    cada2Anos: ipsos(0.412, { lamina: 87, pregunta: P_FRECUENCIA, base: 400 }),
    cada3AnosMas: ipsos(0.417, { lamina: 87, pregunta: P_FRECUENCIA, base: 400, nota: "cada más de 2 años" }),
    cada4Anos: ipsos(0.011, { lamina: 87, pregunta: P_FRECUENCIA, base: 400 }),
  },

  marcas: {
    Apple: ipsos(0.509, { lamina: 87, pregunta: P_MARCA, base: 400 }),
    Samsung: ipsos(0.318, { lamina: 87, pregunta: P_MARCA, base: 400 }),
    Xiaomi: ipsos(0.082, { lamina: 87, pregunta: P_MARCA, base: 400 }),
    Honor: ipsos(0.037, { lamina: 87, pregunta: P_MARCA, base: 400 }),
    Motorola: ipsos(0.023, { lamina: 87, pregunta: P_MARCA, base: 400 }),
    Otros: ipsos(0.031, { lamina: 87, pregunta: P_MARCA, base: 400 }),
  },
};

// Supuestos comerciales (USD)
export const PRECIOS_GAMA_ALTA_SMARTPHONES = [
  supuesto(1000, { nota: "precio gama alta" }),
  supuesto(1200, { nota: "precio gama alta" }),
  supuesto(1400, { nota: "precio gama alta" }),
  supuesto(1600, { nota: "precio gama alta" }),
];
export const PRECIOS_GAMA_MEDIA_SMARTPHONES = [
  supuesto(500, { nota: "precio gama media" }),
  supuesto(600, { nota: "precio gama media" }),
  supuesto(750, { nota: "precio gama media" }),
  supuesto(900, { nota: "precio gama media" }),
];

export const ESCENARIOS_CRECIMIENTO_SMARTPHONES = [
  supuesto(3, { nota: "% crecimiento de share simulado" }),
  supuesto(5, { nota: "% crecimiento de share simulado" }),
  supuesto(10, { nota: "% crecimiento de share simulado" }),
  supuesto(20, { nota: "% crecimiento de share simulado" }),
];

// Tasa de renovación anual ponderada (50% gama alta ~1/1,5 años + 50% gama media ~1/3,5 años)
export const TASA_RENOVACION_ANUAL = supuesto(0.46, { nota: "tasa de renovación anual ponderada" });
